import { Fragment, useState } from "react";
import {
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  useReactTable,
  createColumnHelper,
  SortingState,
} from "@tanstack/react-table";
import { ISupplier } from "../../models/Supplier";
import { TicketIcon } from "@heroicons/react/24/solid";
import SupplierVoucherModal from "./SupplierVoucherModal";




export default function SuppliersTable({ suppliers, setSupplier }: { suppliers: ISupplier[], setSupplier: any }) {
    const [sorting, setSorting] = useState<SortingState>([]);
    const [voucherSupplier, setVoucherSupplier] = useState<ISupplier | null>(null);

    const colHelper = createColumnHelper<ISupplier>();

    const cols = [
        colHelper.display({
            id: "name",
            header: "Name",
            sortingFn: "auto",
            cell: (info) => (
            <span className="flex  " >
                <span className="ml-4 m-auto">{info.row.original.name}</span>
            </span>
            )
        }),
        colHelper.accessor("contact.fullname", {
            header: "Contact Person",
        }),
        colHelper.accessor("contact.email", {
            header: "Email",
        }),
        colHelper.accessor("contact.telephone1", {
            header: "Phone",
        }),
        colHelper.display({
            id: "vouchers",
            header: "Vouchers",
            sortingFn: "auto",
            cell: (info) => (
            <span className="flex" >
                <span className="ml-4 m-auto">
                    {info.row.original.vouchers.length}
                </span>
                <span className="py-2 px-4 bg-primary-600 rounded-md flex text-white
                    transition duration-300 ease-in-out hover:bg-primary-700 hover:cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        // Handle the click event to view vouchers
                        setVoucherSupplier(info.row.original);
                    }}
                >
                    View Vouchers
                    <TicketIcon className="h-5 w-5 text-white ml-5" />
                </span>
            </span>
            )
        }),
    ];
    
    const table = useReactTable({
        data: suppliers,
        columns: cols,
        state: {
            sorting: sorting,
        },
        enableRowSelection: true,
        getExpandedRowModel: getExpandedRowModel(),
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    return (
        <>
            <SupplierVoucherModal
                open={!!voucherSupplier}
                setOpen={() => setVoucherSupplier(null)}
                supplier={voucherSupplier ?? null}
            />
            <div className="mt-4 bg-white overflow-auto">
                <table className="min-w-full overflow-scroll divide-y border divide-gray-300">
                
                    {/* Table headings - very similar to all the other tables */}
                    <thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id} className="bg-gp-blue-50 text-gray-800">
                            {headerGroup.headers.map((header, i) => (
                                <th
                                    key={header.id}
                                    scope="col"
                                    className="py-3.5 px-3 text-sm font-semibold lg:table-cell text-left"
                                >
                                    {header.isPlaceholder
                                    ? null
                                    : (
                                        <div
                                        {...{
                                            className: header.column.getCanSort()
                                            ? 'cursor-pointer select-none'
                                            : '',
                                            onClick: header.column.getToggleSortingHandler(),
                                        }}
                                        >
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                        {{
                                            asc: ' ▲',
                                            desc: ' ▼',
                                        }[header.column.getIsSorted() as string] ?? null}
                                        </div>

                                    )}
                                </th>
                            ))}
                        </tr>
                        ))}
                    </thead>

                    {/* Body */}
                    <tbody>
                        {table.getRowModel().rows.map((row, i) => {
                        let rowCells = row.getVisibleCells();
                        return (
                            <Fragment key={i}>
                            <tr
                                key={row.id}
                                onClick={() => setSupplier(row.original)}
                                className={"hover:bg-gray-100 hover:cursor-pointer"}
                            >
                                {rowCells.map((cell) => (
                                <td key={cell.id} className="px-3 py-3 border text-sm">
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                                ))}
                            </tr>
                            {row.getIsExpanded() && (
                                <></>
                                // <tr>
                                //   {/* 2nd row is a custom 1 cell row */}
                                //   <td colSpan={row.getVisibleCells().length}>
                                //     <LeadsTableSubComponent lead={row.original} />
                                //   </td>
                                // </tr>
                            )}
                            </Fragment>
                        );
                        })}
                    </tbody>

                
                </table>
            </div>
        </>
    );
}